const colors = ["#ea1d25", "#f06923", "#fdb51b", "#fdb51b", "#ea1d25", "#f06923"];

export const generateColors = numberOfColors => {
  if (!numberOfColors) return false;

 

  let fourColors;
  if (numberOfColors === 4) {
    // If there are 4 options we change the last one to prevent same colors from being adjacent
    fourColors = [...colors];
    fourColors[3] = colors[0];
  }

  return fourColors || colors;
};

export default colors;
